/**
 * Created by m.igrachev on 6/16/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Action menu component nests actions, so some children are expected."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "false",
        isRequired: "false",
        description: "Defines extra css classes to be added to Action Menu."
    },
    {
        name: "borders",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "Indicates if border is needed between the action menu items."
    },
    {
        name: "background",
        type: "String",
        defaultValue: "false",
        isRequired: "false",
        description: "The background of the menu. Supported for now: 'dark', 'light'."
    },
    {
        name: "rightIcons",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true puts the icons of the nested action items on the right."
    },
    {
        name: "allowedActionClasses",
        type: "Array",
        defaultValue: '["Action"]',
        isRequired: "false",
        description:
            "A register of the allowed Action class names of the nested actions inside the action menu."
    },
    {
        name: "onSelectItem",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A callback function to be called when action menu item is clicked."
    }
];

export default documentedProperties;
